<div *ngIf="!cssUrl" class="text-center py-5">
  <i class="fas fa-spinner fa-spin fa-7x"></i>
</div>

<div *ngIf="cssUrl">
  <router-outlet></router-outlet>
</div>
